<template>
  <div class="flex flex-col">
    <button
      class="warning-button ml-auto mr-4"
      @click="updateSyncCurrencies()"
      v-if="!loading"
    >
      Sync Currencies
    </button>
    <BaseSmallSpinner v-if="loading"></BaseSmallSpinner>
    <table class="default-table text-center my-6" v-else>
      <thead>
        <th>ID</th>
        <th>Currencie ID</th>
        <th>Code</th>
        <th>Description</th>
      </thead>
      <tbody>
        <tr v-for="currency in currencies" :key="currency.id">
          <td>{{ currency.id }}</td>
          <td>{{ currency.monedaId }}</td>
          <td>{{ currency.code }}</td>
          <td>{{ currency.description }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { getCurrencies, getSyncCurrencies } from "@/api/Infoauto.js";
export default {
  name: "Currencies",
  data() {
    return {
      currencies: [],
      loading: true
    };
  },
  async mounted() {
    try {
      this.currencies = await getCurrencies();
    } catch (e) {
      console.log(e);
    }
    this.loading = false;
  },
  methods: {
    async updateSyncCurrencies() {
      this.loading = true;
      try {
        this.currencies = await getSyncCurrencies();
      } catch (e) {
        console.log(e);
      }
      this.loading = false;
    }
  }
};
</script>
